import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { baseUrl } from "../../api/baseUrl";

const API_BASE_URL = `${baseUrl}/api/v1/`;

// Custom error handling function
const customBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = Cookies.get("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Wrapper for the base query that handles authentication and network errors
const baseQueryWithAuthErrorHandling = async (args, api, extraOptions) => {
  console.log("Fetching user data...");
  const result = await customBaseQuery(args, api, extraOptions);

  console.log("Response received:", result);

  // Check for network connectivity errors
  if (result.error) {
    const { status, data, error } = result.error;

    // Network connectivity issues
    if (
      status === "FETCH_ERROR" ||
      status === "TIMEOUT_ERROR" ||
      error === "Failed to fetch" ||
      error === "NetworkError" ||
      (typeof status === "string" && status.includes("NETWORK_ERROR")) ||
      !navigator.onLine
    ) {
      console.log("Network connectivity error detected:", result.error);

      // Trigger the NoInternetConnection component by dispatching a custom event
      window.dispatchEvent(
        new CustomEvent("network-error", {
          detail: {
            error: result.error,
            timestamp: Date.now(),
          },
        })
      );

      return result;
    }

    // Check for authentication errors
    if (
      data &&
      data.status === "error" &&
      data.error &&
      data.error.message === "Invalid AccessToken"
    ) {
      console.log("Invalid AccessToken detected, logging out user");

      // Remove the token from cookies
      Cookies.remove("token");

      // Redirect to login page
      window.location.href = "/login";
      return result;
    }
  }

  console.log("No authentication or network errors detected");
  return result;
};

export const currentUserApi = createApi({
  reducerPath: "currentUserApi",
  baseQuery: baseQueryWithAuthErrorHandling,
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: () => "provider",
    }),
  }),
});

export const { useGetCurrentUserQuery } = currentUserApi;
